import { Do, guid, timer } from '../../universal';
import { _ } from '../lib';
import { j2h } from './component-j2h';
import { unmountReactOnElement } from './component-react';
import { TOGLOB } from './component-trionline';
export const getNewFlyout = (title, size, locked) => {
    const $D = systemFlyout({
        title,
        size,
        content: '',
        force: !!locked,
    });
    $D.find('.flyout_buttons').remove();
    return $D.find('.floater_body').empty();
};
export const systemFlyout = (I) => {
    let pos_left;
    const obj = ((input) => {
        const obj = input || {};
        const body = obj.body || '<p>Content goes here</p>';
        const finalBody = body.indexOf('<') === -1 ? `<p>${body}</p>` : body;
        let size;
        if (obj.size && obj.size.length >= 2) {
            const s0 = obj.size[0];
            const s1 = obj.size[1];
            size =
                typeof s0 === 'number' && typeof s1 === 'number' ? [s0, s1] : [640, 360];
        }
        else {
            size = [640, 360];
        }
        const ID = obj.ID || `tofloat_${guid()}`;
        const callback = $.isFunction(obj.callback) ? obj.callback : _.noop;
        const coords = obj.coords || [null, null];
        const buttons = obj.buttons || '';
        let html = obj.html;
        if (html === undefined) {
            html = '';
            if (obj.title != null) {
                html += `<div class="flyout_header"><h1>${obj.title}</h1></div>`;
            }
            html += `<div class="floater_body">${finalBody}</div>`;
        }
        if (obj.iframe) {
            html = '';
            if (obj.title != null) {
                html += `<div class="flyout_header"><h1>${obj.title}</h1></div>`;
            }
            html += `<iframe src="${obj.iframe}"></iframe>`;
        }
        let finalButtons = buttons;
        let finalHtml = html;
        if (obj.tabs) {
            const append = Do(() => {
                let tab_html = '';
                let body = '';
                _.each(obj.tabs, (value, key) => {
                    tab_html += `<span class="floating_tab_link" data-key>${key}</span>`;
                    key = key.toLowerCase().replace(/\s/g, '');
                    body += `<div class="floater_body tab tab_${key}">${value}</div>`;
                });
                return [tab_html, body];
            });
            finalButtons = buttons + append[0];
            const body = append[1];
            finalHtml = '';
            if (obj.title != null) {
                finalHtml += `<div class="flyout_header"><h1>${obj.title}</h1></div>`;
            }
            finalHtml += body;
        }
        const force = !!obj.force;
        const autoTab = obj.autoTab || 0;
        let finalSize = size;
        if (obj.sizes && obj.tabs) {
            const tabSize = obj.sizes[autoTab];
            finalSize =
                tabSize &&
                    tabSize.length >= 2 &&
                    typeof tabSize[0] === 'number' &&
                    typeof tabSize[1] === 'number'
                    ? [tabSize[0], tabSize[1]]
                    : [640, 480];
            if (obj.sizes.length !== _.keys(obj.tabs).length) {
                throw new Error('Sizes length mismatched with tab quantity');
            }
        }
        return {
            title: obj.title,
            body: finalBody,
            content: obj.content,
            size: finalSize,
            ID,
            callback,
            coords,
            buttons: finalButtons,
            html: finalHtml,
            iframe: obj.iframe,
            tabs: obj.tabs,
            tabsVertical: obj.tabsVertical,
            force,
            autoTab,
            sizes: obj.sizes,
        };
    })(I);
    const $window = $(window);
    const windowHeight = $window.height() ?? 600;
    const windowWidth = $window.width() ?? 800;
    const [width, height] = obj.size;
    let height_gap = (windowHeight - height) / 4;
    height_gap = -(20 + height_gap + height);
    const initial_height = -20 - height;
    const max_width = windowWidth - 20;
    const max_height = windowHeight - 20;
    if (width > max_width) {
        obj.size[0] = max_width;
    }
    if (height > max_height) {
        obj.size[1] = max_height;
    }
    pos_left = !obj.coords[0] ? `calc((100% - ${width}px) / 2)` : `${obj.coords[0]}px`;
    const $div = $(j2h({
        ID: obj.ID,
        class: `to_floater ${obj.ID}`,
        html: obj.html,
    }));
    $div.css({
        top: `${Math.round(initial_height)}px`,
        left: pos_left,
        width: `${width}px`,
        height: `${height}px`,
        opacity: '1',
    });
    if (!TOGLOB.showFlyoutAnimation) {
        $div.css({ transition: 'none' });
    }
    $div.find('.floater_body.tab').css({ height: 'calc(100% - 42px)' });
    if ($('#hub_body').length > 0) {
        const hubBodyClass = $('#hub_body').attr('class');
        if (hubBodyClass) {
            $div.addClass(hubBodyClass);
        }
    }
    $('body').append($div);
    const $h1 = $div.find('h1');
    const $buttons = $(j2h({
        class: 'flyout_buttons toolbar_buttons noselect',
        html: obj.buttons,
    }));
    $buttons.find('button').each((_i, elem) => {
        const $button = $(elem);
        const img = $button.attr('data-img');
        if (!img) {
            return;
        }
        const label = $button.text();
        const html = `<img src='${img}' /><span>${label}</span>`;
        $button.html(html);
    });
    $buttons.insertAfter($h1);
    $h1.css({ display: 'inline' });
    const heading_width = ($h1.width() ?? 0) + 5;
    $buttons.css({ width: `calc(100% - ${heading_width}px)` });
    if (obj.sizes) {
        const sizes = obj.sizes;
        $div.find('.floating_tab_link').each((i, elem) => {
            const size = sizes[i];
            if (size && size.length >= 2) {
                $(elem).attr({
                    'data-width': size[0],
                    'data-height': size[1],
                });
            }
        });
    }
    let new_height = (($(window).height() ?? 600) - height) / 4;
    if (obj.coords[1] !== null) {
        new_height = obj.coords[1];
    }
    const translation = new_height - initial_height;
    $div.css('transform', `translate(0px, ${translation}px)`);
    $div.find('iframe').css({ height: `${height - 64}px` });
    $div.find('span.floating_tab_link').click(e => {
        const $tab = $(e.currentTarget);
        const $tabs = $tab.parent().children('span.floating_tab_link');
        const $tab_contents = $div.find('div.floater_body.tab');
        const key = $tab.text().toLowerCase().replace(/\s/g, '');
        $tab_contents.hide();
        $tabs.removeClass('selected');
        $tab.addClass('selected');
        return $tab_contents.filter(`.tab_${key}`).each((_i, elem) => {
            const $elem = $(elem);
            if ($elem.hasClass('vertical')) {
                $elem.css({ display: 'inline-block' });
            }
            else {
                $elem.show();
            }
        });
    });
    const duration = TOGLOB.showFlyoutAnimation ? 500 : 0;
    timer(duration, () => {
        const existing_top = parseInt($div.css('top'));
        const new_top = Math.round(existing_top + translation);
        const css = {
            transform: 'translate(0px, 0px)',
            top: `${new_top}px`,
        };
        if (TOGLOB.showFlyoutAnimation) {
            css['transition'] = 'height 0.4s, width 0.4s, opacity 0.2s, left 0.4s';
        }
        $div.css(css);
        $div.find('span.floating_tab_link').click(e => {
            const $tab = $(e.currentTarget);
            const widthStr = $tab.attr('data-width');
            const heightStr = $tab.attr('data-height');
            if (!widthStr || !heightStr) {
                return;
            }
            const width = +widthStr;
            const height = +heightStr;
            if (isNaN(width) || isNaN(height)) {
                return;
            }
            flyoutUpdateSize($div, width, height);
        });
        if ($.isFunction(obj.callback)) {
            obj.callback();
        }
    });
    if (obj.tabsVertical) {
        const $vertical = $(j2h({ class: 'verticalTabPane noselect' }));
        $div.find('.flyout_buttons')
            .find('span.floating_tab_link')
            .each((_i, elem) => {
            $(elem).appendTo($vertical);
        });
        $div.find('.flyout_header').after($vertical);
        $div.find('.floater_body.tab').addClass('vertical');
        $div.find('.flyout_header').find('h1').css({ width: '' });
    }
    $div.find('span.floating_tab_link').eq(obj.autoTab).trigger('click');
    if (TOGLOB.lockLevel === 0 || $('.to_floater:not(.leaving)').length > 1) {
        to_page_lock(obj.force ?? false);
    }
    $div.addClass(`nested_${TOGLOB.lockLevel}`);
    return $div;
};
export const flyoutUpdateSize = ($flyout, width, height) => {
    const $w = $(window);
    const wHeight = $w.height() ?? 600;
    const wWidth = $w.width() ?? 800;
    width = Math.min(width, wWidth - 50);
    height = Math.min(height, wHeight - 50);
    const top = (wHeight - height) / 4;
    const duration = TOGLOB.showFlyoutAnimation ? 500 : 0;
    const d2 = duration === 0 ? 0 : 0.4;
    const d1 = duration === 0 ? 0 : 0.2;
    const t1 = `height ${d2}s, width ${d2}s, opacity ${d1}s, left ${d2}s, top ${d2}s`;
    const t2 = `height ${d2}s, width ${d2}s, opacity ${d1}s, left ${d2}s`;
    const style1 = { transition: t1, '-webkit-transition': t1 };
    const style2 = { transition: t2, '-webkit-transition': t2 };
    $flyout.css(style1);
    $flyout.css({
        width: `${width}px`,
        height: `${height}px`,
        left: `calc((100% - ${width}px) / 2)`,
        top: `${top}px`,
    });
    timer(duration, () => $flyout.css(style2));
};
export const closeMessage = (ID) => {
    const ID_string = ID === undefined ? '' : `#${ID}`;
    let $flyouts = $(`.to_floater${ID_string}`);
    const { lockLevel } = TOGLOB;
    if (lockLevel >= 2) {
        const classes = _.range(1, lockLevel).map(x => `nested_${x}`);
        $flyouts = $flyouts.filter((_i, elem) => {
            let skip = false;
            const $flyout = $(elem);
            classes.forEach(c => {
                if ($flyout.hasClass(c)) {
                    skip = true;
                }
            });
            return !skip;
        });
    }
    try {
        $flyouts.find('*').off();
    }
    catch {
    }
    $flyouts.each((_i, elem) => {
        const $this = $(elem);
        $this.off('*');
        $this.addClass('leaving');
        try {
            const floaterBody = $this.find('.floater_body')[0];
            if (floaterBody) {
                unmountReactOnElement(floaterBody);
            }
            const thisElement = $this[0];
            if (thisElement) {
                unmountReactOnElement(thisElement);
            }
        }
        catch {
        }
        if (!TOGLOB.showFlyoutAnimation) {
            $this.remove();
            return;
        }
        const top_offset = -(($this.height() ?? 0) + 20);
        const current_top = parseInt($this.css('top'));
        const translate = current_top - top_offset;
        $this.css({
            top: `${top_offset}px`,
            transform: `translate(0px, ${translate}px)`,
        });
        timer(50, () => {
            $this.css({
                transition: 'transform 0.2s, height 0.4s, width 0.4s, opacity 0.2s, left 0.4s',
            });
        });
        timer(55, () => {
            $this.css({
                transform: 'translate(0px, 0px)',
                opacity: '0',
            });
        });
        timer(400, () => {
            $this.remove();
        });
    });
};
const to_page_lock = (force) => {
    if (TOGLOB.lockLevel >= 5) {
        return;
    }
    const $lock = TOGLOB.$lock[TOGLOB.lockLevel];
    if (!TOGLOB.showFlyoutAnimation) {
        $lock.css({ transition: 'none' });
    }
    $lock.css({
        transform: 'translate(0px, 0px)',
        opacity: '0.5',
    });
    $lock.on('click', (e) => {
        e.stopImmediatePropagation();
        e.preventDefault();
        to_page_unlock();
    });
    if (force !== false) {
        $lock.addClass('locked');
    }
    $('body').css({ 'overflow-y': 'hidden' });
    to_page_lock_level_change(+1);
};
export const to_page_unlock = (force) => {
    if (TOGLOB.lockLevel <= 0) {
        return;
    }
    const $lock = TOGLOB.$lock[TOGLOB.lockLevel - 1];
    if (!TOGLOB.showFlyoutAnimation) {
        $lock.css({ transition: 'none' });
    }
    if (force === undefined) {
        force = false;
    }
    if ($lock.hasClass('locked') && force === false) {
        return;
    }
    closeMessage(undefined);
    {
        const [d1, d2] = TOGLOB.showFlyoutAnimation ? [100, 400] : [0, 0];
        $lock.off('click');
        timer(d1, () => {
            $lock.css({ opacity: 0 }).removeClass('locked');
            timer(d2, () => {
                const p = '-10000px';
                $lock.css({ transform: `translate(${p}, ${p})` });
            });
        });
    }
    to_page_lock_level_change(-1);
    if (TOGLOB.lockLevel === 0) {
        $('body').css({ 'overflow-y': 'auto' });
    }
    if ($.isFunction(TOGLOB.onFlyoutsClose)) {
        TOGLOB.onFlyoutsClose();
    }
};
export const to_is_locked = () => +TOGLOB.$lock[0].css('opacity') !== 0;
const to_page_lock_level_change = (delta) => {
    TOGLOB.lockLevel += delta;
    if (TOGLOB.lockLevel > 5) {
        TOGLOB.lockLevel = 5;
    }
    else if (TOGLOB.lockLevel < 0) {
        TOGLOB.lockLevel = 0;
    }
};
//# sourceMappingURL=flyouts-old.js.map